export default "__VITE_ASSET__DXgNdVGk__"